'use es6';

import memoize from 'hs-lodash/memoize';
import { BY_CATEGORY as FEATURES_BY_CATEGORY } from 'ecosystem-marketplace-core/constants/groupTags/categoryFeatures';
const getCategoryFeatureValues = memoize(category => Object.values(FEATURES_BY_CATEGORY[category] || {}));
export const filterFeaturesByCategory = (features, category) => {
  const categoryFeatures = getCategoryFeatureValues(category);
  return features.filter(feature => categoryFeatures.includes(feature));
};